if (!customElements.get('comparison-table-scroll')) {
  customElements.define('comparison-table-scroll', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-comparison-viewport]');
      this.scrollbar = this.querySelector('[data-comparison-scrollbar]');
      if (!this.viewport || !this.scrollbar) return;

      this.onScroll = () => this.sync();
      this.onInput = () => {
        const direction = getComputedStyle(this.viewport).direction === 'rtl' ? -1 : 1;
        this.viewport.scrollLeft = Number(this.scrollbar.value) * direction;
        this.sync();
      };
      this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
      this.scrollbar.addEventListener('input', this.onInput);
      window.addEventListener('resize', this.onScroll);

      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.onScroll);
        this.observer.observe(this.viewport);
        for (const child of this.viewport.children) this.observer.observe(child);
      }
      this.sync();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.viewport?.removeEventListener('scroll', this.onScroll);
      this.scrollbar?.removeEventListener('input', this.onInput);
      window.removeEventListener('resize', this.onScroll);
    }

    sync() {
      const max = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      const scrollable = max > 1;
      this.scrollbar.hidden = !scrollable;
      this.toggleAttribute('data-scrollable', scrollable);
      if (!scrollable) return;

      const position = Math.max(0, Math.min(max, Math.abs(this.viewport.scrollLeft)));
      const trackWidth = this.scrollbar.clientWidth;
      const thumbWidth = Math.min(trackWidth, Math.max(32, trackWidth * this.viewport.clientWidth / this.viewport.scrollWidth));
      this.scrollbar.max = String(max);
      this.scrollbar.value = String(Math.round(position));
      this.scrollbar.style.setProperty('--comparison-thumb-width', `${thumbWidth}px`);
      this.scrollbar.setAttribute('aria-valuetext', `${Math.round(position / max * 100)}% scrolled`);
    }
  });
}
